import React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import '../../css/table.css';
import { get } from 'lodash';
import { getComparator, stableSort, TableComponent } from '../../Common/Table';
import { useState } from 'react';
import { Tooltip } from '@mui/material';
import { FaEdit, FaEye } from 'react-icons/fa';
import SelectDropdown from '../../Common/SelectDropdown';

import { postRequest, deleteRequest } from '../interceptor/interceptor';
import { useMediaQuery } from 'react-responsive';
import TableCard from '../../Common/TableCard';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { REMOVE_BUDGET_NEWS } from '../../apiConst';
import { videoTableHeader } from '../../Fields/videoFields';
import DeleteModal from '../../Common/DeleteModal';
import { MdDelete } from 'react-icons/md';
export default function VideosList({
  tableRowsData,
  getListData,
  rowsPerPage,
  setRowsPerPage,
  totalCount,
  page,
  setPage,
  onEdit,
  onView,
  onStepperForm,
  register,
  errors,
}) {
  const isTabletMid = useMediaQuery({ query: '(max-width: 768px)' });
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('id');
  const [searchVal, setSearchVal] = useState('');
  const headers = videoTableHeader;

  const [isLoading, setIsLoading] = useState(false);
  const { role } = useSelector((state) => state.user);
  const [modal, setModal] = useState(false);
  const [dataId, setDataId] = useState('');
  const handleChangePage = async (event, newPage) => {
    console.log('new page: ' + newPage);
    setPage(newPage);
    await getListData(Number(newPage + 1), rowsPerPage, '');
  };

  const handleChangeRowsPerPage = (event) => {
    console.log('event' + event.target.value);
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    getListData(1, parseInt(event.target.value), '');
  };

  const handleSearchFieldDropdown = (e) => {
    if (searchVal) {
      getListData(1, rowsPerPage, searchVal, e.target.value);
    }
  };

  const componentDisplay = () => {
    const cells = headers?.filter(
      (cell) =>
        cell.id === 'videoId' ||
        cell.id === 'videoTitle' ||
        cell.id === 'videoLink'
    );
    const onDelete = (id) => {
      console.log('id: ' + id);
      setIsLoading(true);
      deleteRequest(`${REMOVE_BUDGET_NEWS}module=video&id=${id}`)
        .then((res) => {
          setModal(false);
          setIsLoading(false);
          toast.success('Video Deleted Successfully');
          getListData();
        })
        .catch((error) => {
          setModal(false);
          console.log('error', error);
          setIsLoading(false);
        });
    };
    return (
      <div className="lg:mr-3 lg:w-52 text-center mb-[-15px] w-96">
        <DeleteModal
          dataId={dataId}
          firstButtonText={'Cancel'}
          secondButtonText={'Delete'}
          heading={'Confirm Delete'}
          body={<p>Do you want to remove the video?</p>}
          modal={modal}
          pressSecondButton={(id) => onDelete(id)}
          pressFirstButton={() => setModal(false)}
          pressCloseButton={() => setModal(false)}
        />
        {headers.length > 0 && (
          <SelectDropdown
            fieldName="searchField"
            options={cells}
            optionsLabelKey="label"
            optionsValueKey="id"
            register={register}
            onChange={handleSearchFieldDropdown}
            errors={errors}
            fieldType="select"
            className="min-h-[auto] ml-3 w-48 border-1 bg-light py-2 text-sm text-gray-900 bg-white-900 rounded-md pl-2 focus:outline-none focus:bg-white focus:text-gray-900"
            emptyOption={false}
          />
        )}
      </div>
    );
  };
  const openModal = (item) => {
    setModal(true);
    setDataId(item?.videoId);
  };

  return (
    <React.Fragment>
      <div className="taskList mx-2 shadow-lg bg-white rounded-lg mt-2 p-3">
        {isTabletMid ? (
          <div>
            <div className="grid grid-cols-1 pt-2 pb-2">
              <TableComponent
                numSelected={0}
                searchVal={searchVal}
                headingText={'Video Details'}
                order={order}
                searchBar={true}
                orderBy={orderBy}
                rowCount={(tableRowsData && tableRowsData?.length) || 0}
                tableRowsData={tableRowsData}
                headCells=""
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                setSearchVal={setSearchVal}
                rowsPerPage={rowsPerPage}
                getAllData={getListData}
                componentDisplay={componentDisplay}
              >
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  tableRowsData.map((data) => (
                    <TableCard
                      key={data.videoId}
                      videoId={data.videoId}
                      videoTitle={data.videoTitle}
                      videoLink={data?.videoLink}
                      videoType={data?.videoType}
                      allowedRoles={[
                        'Super-Admin',
                        'Admin',
                        'Web-Portal-Data-Entry',
                      ]}
                      role={role}
                      photo={data.photo}
                      onEdit={
                        role === 'Super-Admin' ||
                        role === 'Admin' ||
                        role === 'Web-Portal-Data-Entry'
                          ? (e) => onEdit(data, e)
                          : undefined
                      }
                      onDelete={() =>
                        role === 'Super-Admin' ||
                        role === 'Admin' ||
                        role === 'Web-Portal-Data-Entry'
                          ? openModal(data)
                          : null
                      }
                    />
                  ))}
              </TableComponent>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage={'Entries per page: '}
                labelDisplayedRows={({ from, to, count }) =>
                  `Showing ${from}-${to} of ${count} entries`
                }
              />
            </div>
          </div>
        ) : (
          <div style={{ width: '100%' }}>
            <TableComponent
              numSelected={0}
              searchVal={searchVal}
              headingText={'Video Details'}
              order={order}
              searchBar={true}
              orderBy={orderBy}
              rowCount={(tableRowsData && tableRowsData.length) || 0}
              tableRowsData={tableRowsData}
              headCells={headers}
              setOrder={setOrder}
              setOrderBy={setOrderBy}
              setSearchVal={setSearchVal}
              rowsPerPage={rowsPerPage}
              getAllData={getListData}
              componentDisplay={componentDisplay}
            >
              <TableBody className="table-body">
                {tableRowsData &&
                  tableRowsData.length > 0 &&
                  stableSort(tableRowsData, getComparator(order, orderBy)).map(
                    (row, index) => {
                      return (
                        <TableRow hover tabIndex={-1} key={index}>
                          {headers.map((cell) => {
                            return (
                              <TableCell key={cell.id + index} className={cell.id === 'sno' ? 'sno-column' : ''}>
                                {cell.id === 'action' ? (
                                  <div className="justify-around items-center flex">
                                    <div onClick={(e) => onEdit(row, e)}>
                                      <FaEdit
                                        size={23}
                                        onClick={(e) => onEdit(row, e)}
                                        className="cursor-pointer text-blue-600 hover:text-blue-800 transition"
                                      />
                                    </div>
                                    {role === 'Super-Admin' ||
                                      (role === 'Web-Portal-Data-Entry' && (
                                        <div onClick={(e) => openModal(row)}>
                                          <MdDelete
                                            size={25}
                                            className="cursor-pointer text-red-600 hover:text-red-800 transition"
                                          />
                                        </div>
                                      ))}
                                  </div>
                                ) : cell.id === 'sno' ? (
                                  index + 1
                                ) : cell.id === 'videoId' ? (
                                  <div
                                    className="text-xs flex cursor-pointer text-blue-800 hover:font-bold"
                                    style={{
                                      pointerEvents:
                                        role === 'user' ? 'none' : 'auto',
                                      // opacity: role === "user" ? 0.5 : 1,
                                    }}
                                  >
                                    <div
                                      onClick={(e) =>
                                        role !== 'user' && onEdit(row, e)
                                      }
                                    >
                                      {get(row, cell.id)}
                                    </div>
                                  </div>
                                ) : cell.id === 'image' ? (
                                  row?.photo !== '' && (
                                    <div className="flex justify-center">
                                      <a
                                        href={row?.photo}
                                        target="__blank"
                                        rel="noopener noreferrer"
                                      >
                                        <img
                                          src={row?.photo}
                                          alt="Uploaded file preview"
                                          className="w-32 h-32 object-cover rounded-md border border-gray-300"
                                        />
                                      </a>
                                    </div>
                                  )
                                ) : cell.id === 'videoLink' ? (
                                  <div className="flex justify-center">
                                    <a
                                      href={get(row, cell.id)}
                                      target="__blank"
                                      rel="noopener noreferrer"
                                      className="text-blue-700 hover:text-blue-900"
                                    >
                                      {' '}
                                      <Tooltip title={get(row, cell.id)}>
                                        <span>
                                          {get(row, cell.id)?.length > 30
                                            ? `${get(row, cell.id)?.slice(
                                                0,
                                                30
                                              )}...`
                                            : get(row, cell.id)}
                                        </span>
                                      </Tooltip>
                                    </a>
                                  </div>
                                ) : (
                                  <Tooltip title={get(row, cell.id)}>
                                    <span>
                                      {get(row, cell.id)?.length > 30
                                        ? `${get(row, cell.id)?.slice(
                                            0,
                                            30
                                          )}...`
                                        : get(row, cell.id)}
                                    </span>
                                  </Tooltip>
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    }
                  )}
              </TableBody>
            </TableComponent>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 100]}
              component="div"
              count={totalCount}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={'Entries per page: '}
              labelDisplayedRows={({ from, to, count }) =>
                `Showing ${from}-${to} of ${count} entries`
              }
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
